const ZENDESK_BASE_URL = 'https://immersvelimited.zendesk.com';

// Bare free-text search rather than a field-scoped one.
// Zendesk search has no OR. Free text covers subject, body and comments.
// Account ids are 32-char hex, a single search token, so there is
// nothing here for Zendesk's tokenizer to split.
export function zendeskCardholderSearchUrl(accountId: string): string {
  return `${ZENDESK_BASE_URL}/agent/search/1?type=ticket&q=${encodeURIComponent(accountId)}`;
}
